import React from 'react';
import { selectCircleIcon } from '@/components/my-network/helpers';
import Loader from '@/components/commons/loader';
import style from '../ModalStyles.module.css';
import { cgEndCard } from '../data';
import { formattedCircle } from '../helpers';

function EndCardHeader({ contactsCircle, loading, isError }) {
    const data = cgEndCard;

    return (
        <div className={`w-full bg-noonBlue rounded-t-lg flex flex-col-reverse md:flex-row items-start justify-between py-8 px-6 ${style.mountainBackgroundBlue}`}>
            <div className="w-full mx-auto flex items-center justify-center">
                <Loader isLoading={loading || isError}>
                    <div className="grid grid-cols-2 grid-rows-2 gap-4 ">
                        {data.cards.map((card, index) => {
                            const formatted = formattedCircle(card.proposedCircle);
                            const key = `end-card-${formatted}`;
                            return (
                                <div key={key} className="w-full flex flex-col items-center justify-center">
                                    <div className="w-full bg-shadeStoneGray px-8 py-6 flex flex-col items-center justify-center rounded-t-lg">
                                        <p className="text-[50px] mb-[-10px]">
                                            <b>{contactsCircle[index]}</b>
                                            %
                                        </p>
                                        <p>Resolved</p>
                                    </div>
                                    <div className=" bg-cirrusWhite flex items-center justify-center w-full rounded-b-lg py-3">
                                        <div className="pr-[8px]">
                                            {selectCircleIcon(formatted, '6')}
                                        </div>
                                        {(formatted) && <p className=" text-[14px] font-bold">{`${formatted}`}</p>}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Loader>
            </div>
        </div>
    );
}

export default EndCardHeader;
